import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { CardViewIcon, Flex, Modal, SwapVertIcon, Text, useModal } from "@pancakeswap-libs/uikit"
import styled, { ThemeContext } from 'styled-components'
import CurrencyLogo from 'components/CurrencyLogo'
import {  Currency } from '@pancakeswap-libs/sdk-v2'
import toPrecision from 'utils/getPrecision'
import BigNumber from 'bignumber.js'
import { TranslateString } from '../../utils/translateTextHelpers'
import useMatchBreakpoints from '../../hooks/useMatchBreakpoints'
import TableLpLcon from './TableLpLcon'
import { getChecksumAddress } from '../../utils/addressHelpers'
import Logo from '../../components/Logo'



const  BorderStyle= styled(Flex)`
    border-right: 2px solid;
    border-left: 2px solid;
    max-height: 280px;
    overflow-y: auto;
    border-image:${({ theme }) => theme.isDark?'linear-gradient(transparent, rgba(200, 220, 201, 1), transparent) 5 5': 'linear-gradient(transparent,rgb(249 140 8),transparent) 5 5'}; 
`

const BodyWrapper = styled(Flex)`
  position: relative;
  max-width: 436px;
  width: 100%;
  z-index: 5;
`
const  AppBodyStyle= styled(BodyWrapper)`
    box-shadow: 0px 0px 0px 0px !important;
`

const Image = styled(Logo)<{isMobile?:boolean}>`
  height: ${props => props.isMobile ? "19px" : '26px'};
  width: ${props => props.isMobile ? "19px" : '26px'};
  display: inline-block;
  vertical-align: middle;
  position: relative;
  z-index: 2;
  vertical-align: middle;
`

const Icon = styled.svg`
  fill: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  position: relative;
  top: 2px;
`

const ChildenTr = styled(Flex)`
   background-color:${({ theme })=>theme.colors.input};
   border-radius: 10px;
`
interface RouterSwapProps {
  distribution: Array<string>;
  outputCurrency:Currency;
  inputCurrency:Currency;
  dealOrders:Array<any>;
}
const RouterSwap: React.FC<RouterSwapProps>=({
  distribution,
  outputCurrency,
  inputCurrency,
  dealOrders
})=>{
   const { isDesktop, isMobile } = useMatchBreakpoints();
   const logAddress="0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04";

   const addressTran=(currencyToken)=>{
     if(currencyToken?.symbol==='SBCH'){
      return logAddress
     }
     return currencyToken.address;
   }
   const RouterModal=()=>{
      return <Modal  title={TranslateString(11040,'Routing details')} >
         <AppBodyStyle>
 
         <Flex justifyContent='space-around' flex={1}  alignItems='center'>
            <Flex pr={3}>
            <Image isMobile={isMobile} srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(addressTran(inputCurrency))}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={inputCurrency?.symbol} />
            </Flex>
            <BorderStyle flexDirection="column" p={3} flex={1}>
              <Flex flex={1}  pl={1}>
                <Flex  flex={1}  ><Text fontSize='14px'>{TranslateString(10086,'Price')}</Text></Flex>
                <Flex  flex={1}  ><Text fontSize='14px'>{TranslateString(13043,'Percentage')}</Text></Flex>
              </Flex>
              <Flex flex={1}  flexDirection='column'>
                {
                  dealOrders.map((t,idx)=>{
                    return<ChildenTr flex={1} p={2} mt={2}>
                       <Flex  flex={1}><Text fontSize='12px'>{toPrecision(new BigNumber(t.price),2)}</Text></Flex>
                       <Flex  flex={1}><Text fontSize='12px'>{new BigNumber(t.tokenARatio).times(new BigNumber(100)).toFixed(0)}%</Text></Flex>
                    </ChildenTr>
                  
                  })
                }
              </Flex>

        
                
            </BorderStyle>
            <Flex pl={3}>
              <Image isMobile={isMobile} srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(addressTran(outputCurrency))}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={outputCurrency?.symbol} />
            </Flex>
         </Flex>

         </AppBodyStyle>
         
        </Modal>
   }
   const [onPresentApyModal] = useModal(RouterModal())
   const handleClickButton = (event): void => {
     event.stopPropagation()
     onPresentApyModal()
   }

   const renderSteps= () => {
      const count = dealOrders.length;
      return count > 0 ? `${count} ${count>1?TranslateString(11048,'Steps'):TranslateString(11047,'Step')}` : "";
   }

   return<>
           <Flex  mb={2} justifyContent='space-between' alignItems='end'>

                <Text fontSize="14px">{TranslateString(11041,'Route') }</Text>
                <Flex>
                  <Text fontSize="14px"  mr={2}>{renderSteps()}</Text>
                  <Text fontSize="14px"><Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" onClick={handleClickButton} width="14px"><path d="m373.332031 0h-85.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969s4.777344 10.664062 10.667969 10.664062h59.582031l-88.457031 88.460938c-2.773438 2.675781-3.882812 6.644531-2.910156 10.371093.976562 3.730469 3.890625 6.644532 7.621094 7.621094 3.726562.972656 7.695312-.136718 10.371093-2.910156l88.460938-88.457031v59.582031c0 5.890625 4.773437 10.667969 10.664062 10.667969s10.667969-4.777344 10.667969-10.667969v-85.332031c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0"/><path d="m109.792969 259.125-88.460938 88.457031v-59.582031c0-5.890625-4.773437-10.667969-10.664062-10.667969s-10.667969 4.777344-10.667969 10.667969v85.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969h85.332031c5.890625 0 10.667969-4.777344 10.667969-10.667969s-4.777344-10.664062-10.667969-10.664062h-59.582031l88.457031-88.460938c4.042969-4.183593 3.984375-10.835937-.128906-14.953125-4.117188-4.113281-10.769532-4.171875-14.953125-.128906zm0 0"/><path d="m373.332031 277.332031c-5.890625 0-10.664062 4.777344-10.664062 10.667969v59.582031l-88.460938-88.457031c-4.183593-4.042969-10.835937-3.984375-14.953125.128906-4.113281 4.117188-4.171875 10.769532-.128906 14.953125l88.457031 88.460938h-59.582031c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h85.332031c5.890625 0 10.667969-4.777344 10.667969-10.667969v-85.332031c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0"/><path d="m36.417969 21.332031h59.582031c5.890625 0 10.667969-4.773437 10.667969-10.664062s-4.777344-10.667969-10.667969-10.667969h-85.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969v85.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.664062-4.777344 10.664062-10.667969v-59.582031l88.460938 88.457031c4.183593 4.042969 10.835937 3.984375 14.953125-.128906 4.113281-4.117188 4.171875-10.769532.128906-14.953125zm0 0"/></Icon></Text>
                </Flex>

            </Flex>
    </>
}
export default RouterSwap
